/**
*
* SalaryFormLabel
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import LabelWrapper from './styles/LabelWrapper';
import LabelAsterisk from './styles/LabelAsterisk';


const Label = React.memo(function Label(props) {
  return (
    <LabelWrapper properties={props.properties} thisStyles={props.thisStyles}>
      {props.title}
      {props.isRequired ?<LabelAsterisk></LabelAsterisk> : ''}
    </LabelWrapper>
  );
});

Label.propTypes = {
  title: PropTypes.string,
  thisStyles: PropTypes.object,
  properties: PropTypes.bool
};

export default Label;
